// @ts-nocheck

export type TicketListWithTicketMessages = typeof TicketListWithTicketMessages[keyof typeof TicketListWithTicketMessages];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketListWithTicketMessages = {
  true: 'true',
  false: 'false',
} as const;
